<script setup lang="ts">
defineProps<{
  meta?: Record<string, unknown>
  latest?: boolean
}>()

function formatDate(value: unknown) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(String(value)))
}
</script>

<template>
  <div class="release-meta">
    <time v-if="meta?.date" :datetime="String(meta.date)">{{ formatDate(meta.date) }}</time>
    <span v-if="meta?.updated" class="release-updated">
      Updated <time :datetime="String(meta.updated)">{{ formatDate(meta.updated) }}</time>
    </span>
    <span v-if="meta?.version || latest" class="release-badges">
      <v-chip v-if="meta?.version" size="small" variant="tonal" class="release-version"> v{{ meta.version }} </v-chip>
      <v-chip v-if="latest" size="small" variant="tonal" color="primary" class="release-latest">Latest</v-chip>
    </span>
  </div>
</template>

<style scoped>
.release-meta,
.release-badges {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.release-meta {
  font-size: 0.8125rem;
  line-height: 1.6;
  color: rgba(var(--v-theme-on-surface), 0.7);
}

.release-badges {
  gap: 8px;
}

.release-version {
  font-variant-numeric: tabular-nums;
}

.release-latest :deep(.v-chip__content) {
  color: rgb(var(--v-theme-on-surface));
}

@media (max-width: 599px) {
  .release-updated {
    flex-basis: 100%;
  }
}
</style>
